/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:20 GMT
 */
/**
 * Do not edit directly
 * Generated on Thu, 24 Oct 2024 00:22:18 GMT
 */
/* mixins & extensions */
/* helper to properly scale internal durations */
/**
* Currently only used in Checkbox.
*/
:host {
  display: inline-flex;
  outline: 2px solid transparent;
  outline-offset: 2px
}

.anchor {
  margin: 0px;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  font-size: var(--calcite-font-size-0);
  line-height: 1.25rem;
  text-decoration-line: none;
  outline-color: transparent;
  transition: background-color, block-size, border-color, box-shadow, color, inset-block-end, inset-block-start, inset-inline-end, inset-inline-start inset-size, opacity, outline-color, transform var(--calcite-animation-timing) ease-in-out 0s, outline 0s, outline-offset 0s;
  color: inherit;
  border-block-end: 2px solid transparent
}

.anchor:hover,
.anchor:focus {
  background-color: var(--calcite-color-foreground-2)
}

.anchor:focus {
  outline: 2px solid var(--calcite-ui-focus-color, var(--calcite-color-brand));
  outline-offset: calc(
            -2px *
            calc(
              1 -
              2 * clamp(
                0,
                var(--calcite-offset-invert-focus),
                1
              )
            )
          )
}

.anchor:active {
  background-color: var(--calcite-color-foreground-3)
}

.image,
.icon {
  margin: 0px;
  display: flex;
  block-size: 1.75rem;
  padding-inline: 1rem
}

.image ~ .icon {
  padding-inline-start: 0px
}

.image ~ .container,
.icon ~ .container {
  padding-inline-start: 0px
}

:host(:active) .anchor {
  color: var(--calcite-color-text-1)
}

:host([active]) .anchor {
  color: var(--calcite-color-text-1);
  border-color: var(--calcite-color-brand);
  --calcite-icon-color: var(--calcite-color-brand)
}

.container {
  margin-block-start: 0.125rem;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-inline: 1rem;
  text-align: start
}

.heading {
  margin-inline-start: 0px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: var(--calcite-font-size-0);
  font-weight: var(--calcite-font-weight-medium);
  color: var(--calcite-color-text-1)
}

.standalone {
  font-size: var(--calcite-font-size-1)
}

.description {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--calcite-color-text-2);
  font-size: var(--calcite-font-size--1)
}

:host([hidden]) {
  display: none
}

[hidden] {
  display: none
}